<template>
  <div class="kbli-container">
    <div class="modal-company-kbli-wrapper">
      <div class="column100 flex-row">
        <div class="text-bold column10">No</div>
        <div class="text-bold column40">Jenis Usaha</div>
        <div class="text-bold column10">Kualifikasi</div>
        <div class="text-bold column20">Bidang</div>
        <div class="text-bold column20">Sub Bidang</div>
      </div>
      <div
        class="column100 flex-row mt10"
        v-if="iujptlVendor.length > 0"
        v-for="(list, index) in iujptlVendor"
        :key="index"
      >
        <div class="column10">{{ index + 1 }}</div>
        <div class="column40">{{ list.master_iujptl.jenis_usaha }}</div>
        <div class="column10">{{ list.master_iujptl.kualifikasi }}</div>
        <div class="column20">{{ list.master_iujptl.bidang }}</div>
        <div class="column20">{{ list.master_iujptl.sub_bidang }}</div>
      </div>
    </div>

    <div class="kbli-mobile-container for-mobile">
      <div
        class="kbli-mobile-list"
        v-if="iujptlVendor.length > 0"
        v-for="(list, index) in iujptlVendor"
        :key="index"
      >
        <div class="w-full text-gray">Jenis Usaha</div>
        <div class="w-full">{{ list.master_iujptl.jenis_usaha }}</div>
        <div class="w-full text-gray">Kualifikasi</div>
        <div class="w-full">{{ list.master_iujptl.kualifikasi }}</div>
        <div class="w-full text-gray">Bidang</div>
        <div class="w-full">{{ list.master_iujptl.bidang }}</div>
        <div class="w-full text-gray">Sub Bidang</div>
        <div class="w-full">{{ list.master_iujptl.sub_bidang }}</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {}
  },
  computed: {
    iujptlVendor() {
      return this.$store.state.level1.iujptlVendor
    },
  },
  created() {},
  methods: {},
}
</script>
